<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <theme-picker @change="themeChange" v-show="false" /> -->
    <transition
      name="fade"
      mode="out-in"
      v-if="isRouterAlive"
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { removeOperateTime,removeLogoutFlag } from "@/utils/auth";
import variables from '@/styles/element-variables.scss'
// import themePicker from '@/components/ThemePicker'
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      variables:variables
    };
  },
  components:{},//themePicker
  computed:{
   /*  defaultTheme(){
        return this.$store.state.settings.theme
    } */
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  created() {
    this.changeColor()
  },
  mounted() {
   /*  if (localStorage.getItem('theme')) {
      this.themeChange(localStorage.getItem('theme'))
    } */
    window.addEventListener("beforeunload", () => {
        removeLogoutFlag()
        // removeOperateTime()
    });
    // console.log(" ......................阿弥陀佛......................\n"+
    //             "                       _oo0oo_                      \n"+
    //             "                      o8888888o                     \n"+
    //             "                      88\" . \"88                     \n"+
    //             "                      (| -_- |)                     \n"+
    //             "                      0\\  =  /0                     \n"+
    //             "                   ___/‘---’\\___                   \n"+
    //             "                  .' \\|       |/ '.                 \n"+
    //             "                 / \\\\|||  :  |||// \\                \n"+
    //             "                / _||||| -卍-|||||_ \\               \n"+
    //             "               |   | \\\\\\  -  /// |   |              \n"+
    //             "               | \\_|  ''\\---/''  |_/ |              \n"+
    //             "               \\  .-\\__  '-'  ___/-. /              \n"+
    //             "             ___'. .'  /--.--\\  '. .'___            \n"+
    //             "         .\"\" ‘<  ‘.___\\_<|>_/___.’>’ \"\".          \n"+
    //             "       | | :  ‘- \\‘.;‘\\ _ /’;.’/ - ’ : | |        \n"+
    //             "         \\  \\ ‘_.   \\_ __\\ /__ _/   .-’ /  /        \n"+
    //             "    =====‘-.____‘.___ \\_____/___.-’___.-’=====     \n"+
    //             "                       ‘=---=’                      \n"+
    //             "                                                    \n"+
    //             "....................佛祖保佑 ,永无BUG...................")

    // 定时检查版本号
    // 定时器，vue对象嵌套太深，只能写在window对象下，方便清除。
    window.timeForRefresh = setInterval(() => {
      window.checkNewVersion(() => {
          MessageBox.confirm('发现有新版本,请立即升级', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
        window.location.reload(true)
          })
      })
    }, 1000 * 60 * 10)

  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    changeColor(){
        variables.colorPrimary = '#2C477F'
    }
   /*  themeChange (val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: val
      })
    } */
  },
  beforeDestroy(){
    clearInterval(window.timeForRefresh)
  }
};
</script>

<style lang="scss">
@import "~scss_index";
@import "~scss_vars";
// @import "~scss_element-variables";
body {
  margin: 0px;
  padding: 0px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}
#app {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.el-submenu [class^="fa"] {
  vertical-align: -1px;
  margin-right: 10px;
}
.el-menu-item [class^="fa"] {
  vertical-align: baseline;
  margin-right: 10px;
}
.toolbar {
  font: 14px "微软雅黑";
  color: $color-primary;
  background: #f2f2f2;
  padding: 10px 15px;
  margin: 10px 0px;
  .el-form-item {
    margin-bottom: 10px;
  }
}
.headTip {
  padding: 10px 15px;
  margin: 10px auto;
  font: 14px "微软雅黑";
  color: #fff;
  background: $color-primary;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
/*滚动条*/
::-webkit-scrollbar-track-piece {
  background-color: #fff;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #ccc;
  background-clip: padding-box;
  min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/App.vue